module.exports = __webpack_public_path__ + "img/Soya.ff09a6cf.svg";